var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.52851 10.4712C3.26816 10.2109 3.26816 9.78878 3.52851 9.52843L7.52851 5.52843C7.78886 5.26808 8.21097 5.26808 8.47132 5.52843L12.4713 9.52843C12.7317 9.78878 12.7317 10.2109 12.4713 10.4712C12.211 10.7316 11.7889 10.7316 11.5285 10.4712L7.99992 6.94265L4.47132 10.4712C4.21097 10.7316 3.78886 10.7316 3.52851 10.4712Z",
    fill: "#313237"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.81f93ebbd7c744c9587bf33fbd164233.svg";
export { ForwardRef as ReactComponent };